import { createSelector } from '@ngrx/store';

import { RootState } from '../root-store/root.state';

export const selectSeReportFeatureState = (state: RootState) => state.report;

export const selectSeReportCurrentExaminationIds = createSelector(
    selectSeReportFeatureState,
    (state) => state.currentExaminationIds,
);

export const selectSeReportIsModified = createSelector(selectSeReportFeatureState, (state) => state.isModified);

export const selectSeReportIsPreview = createSelector(selectSeReportFeatureState, (state) => state.isPreview);

export const selectSeReportKeyImages = createSelector(selectSeReportFeatureState, (state) => state.keyImages);

export const selectSeReportPatientId = createSelector(selectSeReportFeatureState, (state) => state.patientId);

export const selectSeReportImagesPerRowInPlaceholder = createSelector(selectSeReportFeatureState, (state) => state.imagesPerRowInPlaceholder);
